import apiInstanceV2 from "../../Apis/AxiosV2";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {ATTENDANCE_ADJUSTMENT_SERVICE} from "../EndPoints";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const GetAttendancePeriodActive = createAsyncThunk(
    'attendanceAdjustmentSection/getAttendancePeriodActive',
    async () => {
        const result = await apiInstanceV2
            .get(ATTENDANCE_ADJUSTMENT_SERVICE.getAttendancePeriodActive)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
export const GetAttendancePeriodReview = createAsyncThunk(
    'attendanceAdjustmentSection/getAttendancePeriodReview',
    async () => {
        const result = await apiInstanceV2
            .get(ATTENDANCE_ADJUSTMENT_SERVICE.getAttendancePeriodReview)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetAttendancePeriodRequest = createAsyncThunk(
    'attendanceAdjustmentSection/getAttendancePeriodRequest',
    async () => {
        const result = await apiInstanceV2
            .get(ATTENDANCE_ADJUSTMENT_SERVICE.getAttendancePeriodRequest)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetAttendanceAdjustmentGroupById = createAsyncThunk(
    'attendanceAdjustmentSection/getAttendanceAdjustmentGroupById',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${ATTENDANCE_ADJUSTMENT_SERVICE.getAttendanceAdjustmentGroupById}${id}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const GetAttendanceAdjustmentGroupPendingList = createAsyncThunk(
    'attendanceAdjustmentSection/getAttendanceAdjustmentGroupPendingList',
    async (id) => {
        const result = await apiInstanceV2
            .get(`${ATTENDANCE_ADJUSTMENT_SERVICE.getAttendanceAdjustmentGroupPendingList}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);


export const AttendanceAdjustmentApprovalAction = createAsyncThunk(
    'attendanceAdjustmentSection/attendanceAdjustmentApprovalAction',
    async (params) => {
        const result = await apiInstanceV2
            .put(`${ATTENDANCE_ADJUSTMENT_SERVICE.attendanceAdjustmentApprovalAction}`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const SaveAttendanceAdjustment = createAsyncThunk(
    'attendanceAdjustmentSection/saveAttendanceAdjustment',
    async (params) => {
        const result = await apiInstanceV2
            .post(`${ATTENDANCE_ADJUSTMENT_SERVICE.saveAttendanceAdjustment}`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const ValidateAttendanceAdjustmentDate = createAsyncThunk(
    'attendanceAdjustmentSection/validateAttendanceAdjustmentDate',
    async (params) => {
        const result = await apiInstanceV2
            .post(`${ATTENDANCE_ADJUSTMENT_SERVICE.validateAttendanceAdjustmentDate}`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const AdjustAttendanceSubmissionGroup = createAsyncThunk(
    'attendanceAdjustmentSection/adjustAttendanceSubmissionGroup',
    async (params) => {
        const result = await apiInstanceV2
            .put(`${ATTENDANCE_ADJUSTMENT_SERVICE.adjustAttendanceSubmissionGroup}`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);

export const AdjustAttendanceChangeRequestSubmission = createAsyncThunk(
    'attendanceAdjustmentSection/adjustAttendanceChangeRequestSubmission',
    async (params) => {
        const result = await apiInstanceV2
            .put(`${ATTENDANCE_ADJUSTMENT_SERVICE.adjustAttendanceChangeRequestSubmission}`, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });

        const { data, status } = result;

        return { data, status };
    },
);
